module.exports = __webpack_public_path__ + "static/img/16.38023b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/16.jpg
// module id = sGch
// module chunks = 4